import I18n from '~/src/common/services/I18n';
import useProposalForm from '~/src/screens/SearchProductsScreen/useProposalForm';

import * as S from './layout';

const ProposalForm = () => {
  const {
    isInputDisplayed,
    isLoading,
    isDisabled,
    isSent,
    handleSubmit,
    inputRef,
    handleButtonClick,
    handleInputChange,
  } = useProposalForm();

  return (
    <S.FormContainer>
      <S.ProposalForm
        onSubmit={e => {
          void handleSubmit();
          e.preventDefault();
        }}>
        <S.FormText>
          {I18n.translate({
            value: `search-products-screen.no-result-form.proposal-${isSent ? 'sent' : 'title'}`,
          })}
        </S.FormText>
        {isInputDisplayed ? (
          <div>
            <S.Input
              ref={inputRef}
              onChange={handleInputChange}
              aria-label={I18n.t('search-products-screen.no-result-form.input-aria-label')}
              maxLength={100}
            />
            <S.SubmitButton
              type="submit"
              icon="Chevron-right"
              loading={isLoading}
              disabled={isDisabled}
              aria-label={I18n.t('search-products-screen.no-result-form.submit-aria-label')}
            />
          </div>
        ) : (
          <S.Button
            onClick={handleButtonClick}
            aria-label={I18n.t(
              `search-products-screen.no-result-form.button-text${isSent ? '-sent' : ''}`,
            )}>
            {I18n.t(`search-products-screen.no-result-form.button-text${isSent ? '-sent' : ''}`)}
          </S.Button>
        )}
      </S.ProposalForm>
    </S.FormContainer>
  );
};

export default ProposalForm;
